module.exports = __webpack_public_path__ + "img/default.89ac2e04.png";